import { render, staticRenderFns } from "./OrderSidebar.vue?vue&type=template&id=0549737f&scoped=true"
import script from "./OrderSidebar.vue?vue&type=script&lang=js"
export * from "./OrderSidebar.vue?vue&type=script&lang=js"
import style0 from "./OrderSidebar.vue?vue&type=style&index=0&id=0549737f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0549737f",
  null
  
)

export default component.exports